import { AxiosResponse } from 'axios';
import { AuthenticatedClient, ContactResponseType } from '_api';

export const getContacts = (userEmail: string): Promise<AxiosResponse<ContactResponseType[]>> => {
    return AuthenticatedClient.get('/contacts/' + userEmail);
};
